export default __webpack_public_path__ + "static/media/Guru-Parampara-05.965f3a69.png";